import { render, staticRenderFns } from "./Detailpromo.vue?vue&type=template&id=1cfad3a8&"
import script from "./Detailpromo.vue?vue&type=script&lang=js&"
export * from "./Detailpromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports